/**
 * user - forget password
 *
 * @author Shigq
 * @date 2021/6/16 17:20
 */
import { t, REQ_ITEM_TYPE, validatorComp } from '../base'

// import validatorCompCurrentProject from '@/compositions/modules/validator'
import { useI18n } from '@/plugins/i18n'
const {  validateEmail, validatePassword, validateEmailRegister } = validatorComp()
// const { validatePasswordCurrentProject } = validatorCompCurrentProject()
const { isLocal } = useI18n()

const ForgetPasswordReq = [
  {
    prop: 'zoneNumber',
    type: REQ_ITEM_TYPE.SELECT,
    rules: [
      { required: true, trigger: 'blur', message: t('modules.forgetPassword.validate.zoneNumber') }
    ],
    default: isLocal ? '+86' : '+65'
  }, {
    prop: 'cellphone',
    label: t('global.label.cellphone'),
    type: REQ_ITEM_TYPE.INPUT,
    rules: [
      { required: true, trigger: 'blur', message: t('global.validate.mobilePhone') }
    ],
    default: ''
  }, {
    prop: 'smsCode',
    label: t('global.label.cellphoneCode'),
    type: REQ_ITEM_TYPE.INPUT,
    rules: [
      { required: true, trigger: 'blur', message: t('global.validate.mobilePhoneCode') }
    ],
    default: ''
  }, {
    prop: 'smsId',
    rules: [
      { required: true, trigger: 'blur', message: t('global.validate.mobilePhoneCode') }
    ],
    default: ''
  }, {
    prop: 'email',
    label: t('global.label.email'),
    type: REQ_ITEM_TYPE.INPUT,
    rules: [
      { required: true, trigger: 'blur', validator: validateEmail },
      { trigger: 'blur', validator: validateEmailRegister }
    ],
    default: ''
  }, {
    prop: 'emailCode',
    label: t('global.label.emailCode'),
    type: REQ_ITEM_TYPE.INPUT,
    rules: [
      { required: true, trigger: 'blur', message: t('global.validate.emailCode') }
    ],
    default: ''
  }, {
    prop: 'emailId',
    rules: [
      { required: true, trigger: 'blur', message: t('global.validate.emailCode') }
    ],
    default: ''
  }, {
    prop: 'password',
    label: t('modules.forgetPassword.label.password'),
    placeholder: t('global.validate.passwordRule'),
    rules: [
      { required: true, trigger: 'blur', message: t('global.validate.password') },
      { trigger: 'blur', validator: validatePassword }
    ],
    default: ''
  }, {
    prop: 'confirmPwd',
    label: t('global.label.confirmPassword'),
    rules: [
      { required: true, trigger: 'blur', message: t('global.validate.confirmPassword') }
    ],
    default: ''
  }
]

export {
  ForgetPasswordReq
}
